export default "__VITE_ASSET__ml_wvNDI__"